module.exports = __webpack_public_path__ + "img/12CH_Vin.1a7e4f1c.png";